import { setUserData } from './user.actions';
import { signIn } from '../../cognito/organizationApi';
export var LOGIN_ERROR = 'LOGIN_ERROR';
export var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export function submitLogin(_a, canClearViewOnlyMode) {
    var username = _a.username, password = _a.password;
    if (canClearViewOnlyMode === void 0) { canClearViewOnlyMode = true; }
    return function (dispatch, getState) {
        signIn(username.toLocaleLowerCase(), password)
            .then(function (res) {
            if (canClearViewOnlyMode) {
                localStorage.removeItem('isViewOnlyMode');
            }
            dispatch(setUserData({
                role: 'member',
                data: {
                    token: res.token,
                    displayName: username,
                    photoUrl: 'assets/images/avatars/profile.jpg',
                    email: username.toLocaleLowerCase(),
                },
            }));
            dispatch({
                type: LOGIN_SUCCESS,
            });
        })
            .catch(function (err) {
            var payload = err.message === 'User does not exist.'
                ? {
                    username: err.message,
                    password: null,
                }
                : {
                    username: null,
                    password: err.message,
                };
            return dispatch({
                type: LOGIN_ERROR,
                payload: payload,
            });
        });
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/auth/store/actions/login.actions.ts
// module id = 437
// module chunks = 81